import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isQuizShortText(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.QUIZ_SHORT_TEXT && typeof label === 'string' && typeof value === 'string';
}
function format(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatQuizShortText(submission) {
  if (isQuizShortText(submission)) {
    return format(submission);
  }
  return undefined;
}
//# sourceMappingURL=quiz-short-text-preview.js.map